import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
	}), /* @__PURE__ */ _jsx("circle", {
		fill: "none",
		cx: 12,
		cy: 7,
		r: 4
	})]
});
export { SvgUser as ReactComponent };
